import Slideshow from "./Carousel";
import { useEffect, useState } from "react";
import Loader from "./Loader";
import Header from "./Header";
import Courses_Hp from "./Courses_HP";
import Partners from "./Partners";
// import TestimonialCards from "./Testimonials";
import Footer from "./footer"; 
import TestiTemp from "./TestiTemp"
import TestimonialCards from "./Testimonials";


const HomePage = () => {
    const [isLoader, setIsLoader] = useState(true)

    useEffect(() => {
        setTimeout(() => setIsLoader(false), 1700)
    }, [])

    return (
        <div>

            {isLoader ? <Loader /> :
                <div>
                    <Header />

                    <div>
                        <Slideshow />
                    </div>
                    <br />
                  
                    <div>
                        <div style={{ fontSize: "larger" }}><b>ONLINE LEARNING PROGRAM</b></div>
                        <div>Courses are designed and developed by the expert Cobtent Developer</div>
                    </div>
                    <Courses_Hp></Courses_Hp>
                    <Partners />
                    <TestimonialCards />
                    {/* <TestiTemp /> */}
                    <Footer />
                </div>

            }
        </div>
    )
}

export default HomePage;